<template>
  <div class="move-your-podcast__container">
    <div class="move-your-podcast__content">
      <div>
        <Heading class="move-your-podcast__content-title" size="h3">
          {{ $t('pages.ssr_features.pages.common.move_your_podcast.title') }}
        </Heading>
        <Box mb="4">
          <Paragraph>
            {{ $t('pages.ssr_features.pages.common.move_your_podcast.description') }}
          </Paragraph>
        </Box>
        <a
          class="move-your-podcast__content-button"
          :href="$locatedLink('/switch-to-rss/')"
        >
          {{ $t('pages.ssr_features.pages.common.move_your_podcast.button') }}
        </a>
      </div>
      <img
        class="move-your-podcast__content-image"
        src="/images/features/common/move_your_podcast.png"
        srcset="/images/features/common/move_your_podcast@2x.png 2x"
        :alt="$t('pages.ssr_features.pages.common.move_your_podcast.image_alt')"
      >
    </div>
  </div>
</template>

<script>

import Heading from '@/components/common/Heading/Heading'
import Box from '@/components/common/Box/Box'
import Paragraph from '@/components/common/Paragraph/Paragraph'

export default {
  components: {
    Heading,
    Box,
    Paragraph
  }
}
</script>

<style lang="scss" scoped>
.move-your-podcast {
  &__container {
    width: 100%;
    padding: 0 $gap;
    display: flex;
    flex-direction: row;
    align-items: center;

    @include display-less(desktop) {
      padding: 0;
    }
  }

  &__content {
    margin: $gap * 5 auto;
    max-width: 1120px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: $gap * 1.5;
    background-color: #25163A;
    padding: 0 $gap * 1.5 0 $gap * 2.5;
    border-radius: $gap;

    @include display-less(desktop) {
      margin: 0;
      flex-direction: column;
      border-radius: 0;
      padding-left: $gap;
      padding-right: $gap;
    }

    &-title {
      margin-bottom: $gap;
      @include display-less(desktop) {
        margin-top: $gap * 5;
      }
    }

    &-button {
      display: block;
      width: fit-content;
      color: #FFFFFF;
      text-decoration: none;
      background-color: $colorLightPurple;
      padding: $gap * 0.5 $gap * 1.5;
      font-weight: 700;
      border-radius: 4px;

      @include display-less(desktop) {
        text-align: center;
        width: 100%;
      }
    }

    &-image {
      max-width: 500px;

      @include display-less(hd) {
        max-width: 400px;
      }

      @include display-less(desktop) {
        max-width: 500px;
        width: 100%;
      }
    }
  }

}
</style>
